import * as actionTypes from '../actions/actionTypes';
import { detectClientType } from '../utils/gaAnalytics';

const {
  SIGNUP_START_FAIL,
  PUT_FINANCIAL_FAIL,
  PUT_FINANCIAL_SUCCESS,
  CHANGE_PASSWORD_SUCCESS,
} = actionTypes;

export default (store) => (next) => (action) => {
  if (!(window.dataLayer && window.dataLayer.push)) {
    return next(action);
  }
  const {
    meta, error, result, type, isPromise, promiseStatus,
  } = action;

  const customerAlreadyExists = type === SIGNUP_START_FAIL
    && [1401, 1474, 1414].indexOf(error.data.errCode) !== -1;
  const promiseSuccess = isPromise && promiseStatus === 'SUCCESS';
  const financialFailed = isPromise && promiseStatus === 'FAILURE' && type === PUT_FINANCIAL_FAIL;
  const financialSuccess = promiseSuccess && type === PUT_FINANCIAL_SUCCESS;
  let analyticsData = meta ? meta[`analytics${COUNTRY}`] : null;
  const canSendData = !isPromise
    || financialSuccess
    || financialFailed
    || customerAlreadyExists
    || promiseSuccess;
  const offerNoHit = analyticsData ? analyticsData.page === 'offer_no_hit' : false;
  if (canSendData && analyticsData) {
    const state = store.getState();
    if (DEBUG) {
      console.log(state);
    }
    analyticsData = analyticsData(state, action);
    if (COUNTRY === 'LV') {
      /*
      * If customer tried to login and AIO answered with response "Customer exists",
      * we ask for password and show login view.
      */
      if (customerAlreadyExists) {
        analyticsData.pageType = 'login';
      }

      /*
      * When customer submits temporary password received by mobile,
      * we show page when customer is able to crete new password.
      */
      if (result && result.data && result.data.authenticationMethod && result.data.authenticationMethod === 'OTP') {
        analyticsData = {
          event: 'newpage',
          pageType: 'newpassword',
        };
      }

      /*
      * Send clientType on step 1 after successfull password change based on AIO data
      */
      if (type === CHANGE_PASSWORD_SUCCESS) {
        analyticsData.clientType = detectClientType(state);
      }
    }
    if (COUNTRY === 'ES' || COUNTRY === 'LT') {
      analyticsData.event = meta.event;
    }

    /*
    * When financialData is submitted
    * we show either offer page or rejection page.
    * In both cases we are sending "step: 7" to google analytics and only on 7th step
    * we add extra option 'without offer' or 'with offer'.
    */
    let option;
    if (financialFailed) {
      if (COUNTRY !== 'CZ') {
        /*
        * If financialData submittion is failed, we send 'reject' event to GA.
        * but not for CZ, CZ rejection is handled in LoanFormContainer
        */
        const analyticsRejectionData = {
          event: 'reject',
          clientType: analyticsData.clientType,
          applicationID: `${analyticsData.applicationID}`,
          userId: `${analyticsData.userId}`,
        };

        /*
        * If possible, we add statusCode from AIO response.
        */
        if (error && error.data && error.data.statusCode) {
          analyticsRejectionData.alert_msg = error.data.statusCode;
        }
        dataLayer.push(analyticsRejectionData);
      }

      option = `${analyticsData.clientType} without offer`;
      if (COUNTRY === 'MX') {
        option = 'without offer';
      }
    }
    if (COUNTRY !== 'LT' && !(COUNTRY === 'MX' && offerNoHit)) {
      if (financialSuccess) {
        option = `${analyticsData.clientType} with offer`;
        if (COUNTRY === 'MX') {
          option = 'with offer';
        }
      }
      if (option) {
        analyticsData.ecommerce.checkout.actionField.option = option;
      }
    }

    if (analyticsData) {
      dataLayer.push(analyticsData);
    }
  }

  /*
  * All errors are pushged to GA, except errors: 1401, 1474, 1414.
  */
  if (
    (error && error.message)
    || (
      error
      && error.data
      && error.data.message
      && [1401, 1474, 1414].includes(error.data.errCode)
    )
  ) {
    let errorMessage = error.message ? error.message : error.data.message;
    const isErrorWithSensitiveInformation = errorMessage.match(
      /^(LV|FI|ES|PL|EE|AU|MX|LT|CZ):.*/
    );
    if (isErrorWithSensitiveInformation) {
      // Remove sensitive infromation from error after first period.
      errorMessage = errorMessage.replace(/\..*$/i, '');
    }
    const event = { event: 'error_msg', alert_msg: errorMessage };
    if (COUNTRY === 'CZ') {
      const { loan: { currentStep, steps = {} } = {} } = store.getState();
      const step = steps[currentStep];
      if (step && step.analyticsStepName) {
        event.page = step.analyticsStepName.replace(/CZ$/, '');
      }
    }
    dataLayer.push(event);
  }
  return next(action);
};
